var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 3H13.75V2.25C13.75 1.00734 12.7427 0 11.5 0H8.5C7.25734 0 6.25 1.00734 6.25 2.25V3H2.125C1.08948 3 0.25 3.83948 0.25 4.875V6.375C0.25 6.78923 0.585766 7.125 1 7.125H19C19.4142 7.125 19.75 6.78923 19.75 6.375V4.875C19.75 3.83948 18.9105 3 17.875 3ZM7.75 2.25C7.75 1.83656 8.08656 1.5 8.5 1.5H11.5C11.9134 1.5 12.25 1.83656 12.25 2.25V3H7.75V2.25Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67328 8.625C1.53945 8.625 1.43281 8.73684 1.43919 8.87053L2.05794 21.8569C2.11512 23.0588 3.10231 24 4.30512 24H15.6948C16.8976 24 17.8848 23.0588 17.942 21.8569L18.5607 8.87053C18.5671 8.73684 18.4605 8.625 18.3267 8.625H1.67328ZM13 10.5C13 10.0856 13.3356 9.75 13.75 9.75C14.1643 9.75 14.5 10.0856 14.5 10.5V20.25C14.5 20.6644 14.1643 21 13.75 21C13.3356 21 13 20.6644 13 20.25V10.5ZM9.24997 10.5C9.24997 10.0856 9.58559 9.75 9.99997 9.75C10.4143 9.75 10.75 10.0856 10.75 10.5V20.25C10.75 20.6644 10.4143 21 9.99997 21C9.58559 21 9.24997 20.6644 9.24997 20.25V10.5ZM5.49997 10.5C5.49997 10.0856 5.83559 9.75 6.24997 9.75C6.66434 9.75 6.99997 10.0856 6.99997 10.5V20.25C6.99997 20.6644 6.66434 21 6.24997 21C5.83559 21 5.49997 20.6644 5.49997 20.25V10.5Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.550219e44072d49b9f336e902db24776.svg";
export { ForwardRef as ReactComponent };